<template>
  <v-dialog v-model="dialog" scrollable width="700">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Cập nhật đồng phục</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <UniformForm ref="uniformForm" :uniformData="localUniformData" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import UniformForm from '@/modules/uniform/UniformForm.vue'
import { mapActions } from 'vuex'

export default {
  components: { UniformForm },
  props: {
    state: Boolean,
    uniformData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialog: false,
      localUniformData: {}
    }
  },
  methods: {
    ...mapActions('Uniformes', ['updateUniform', 'uploadImage', 'destroyImage']),

    cancel() {
      this.dialog = false
      this.localUniformData = {}
      if (this.$refs.uniformForm) {
        this.$refs.uniformForm.resetValidation()
        this.$refs.uniformForm.resetDefault()
      }
      this.$emit('update:state', false)
    },

    async save() {
      if (!this.$refs.uniformForm.validate()) return

      this.$loading.active = true
      try {
        const data = this.$refs.uniformForm.getData()

        const combinations = data.uniformCombinations.map(comb => {
          return {
            ...comb,
            price: Number(comb.price || 0)
          }
        })

        const payload = {
          id: this.uniformData._id,
          name: data.name,
          note: data.note,
          academicLevel: data.academicLevel,
          activeStatus: data.activeStatus,
          uniformCombinations: combinations
        }

        const imageUrls = data.images.filter(img => typeof img === 'string')
        const imageFiles = data.images.filter(img => img instanceof File)

        // Lọc ra những ảnh cần xóa và không còn tồn tại trong danh sách mới
        const imagesToRemove = this.uniformData.images.filter(img => !imageUrls.includes(img.url))

        // Xóa ảnh cũ
        for (let image of imagesToRemove) {
          await this.destroyImage(image.id)
        }

        if (imageFiles.length > 0) {
          const formData = new FormData()
          imageFiles.forEach(file => {
            formData.append('files', file)
          })
          formData.append('refId', this.uniformData._id)
          formData.append('ref', 'uniform')
          formData.append('field', 'images')

          await this.uploadImage(formData)
        }

        await this.updateUniform(payload)

        this.$refs.uniformForm.resetDefault()
        this.dialog = false
        this.$alert.updateSuccess()
        this.$emit('update:state', false)
      } catch (error) {
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    }
  },
  watch: {
    state(val) {
      if (val) {
        this.dialog = true
        this.localUniformData = JSON.parse(JSON.stringify(this.uniformData))
      }
    }
  }
}
</script>
